import axios from "axios";

/** Directus base (Insights → Pricing Reports). */
export const BEEF_AI_BASE_URL = (process.env.REACT_APP_PRICE_DIRECTUS_URL || "").replace(/\/$/, "");

/** Static read token for Directus items. */
export const BEEF_AI_ACCESS_TOKEN = process.env.REACT_APP_PRICE_DIRECTUS_TOKEN || "";

if (!BEEF_AI_BASE_URL || !BEEF_AI_ACCESS_TOKEN) {
  // eslint-disable-next-line no-console
  console.warn(
    "Missing Beef AI env vars: REACT_APP_PRICE_DIRECTUS_URL / REACT_APP_PRICE_DIRECTUS_TOKEN"
  );
}

/**
 * @param {import("axios").AxiosError} error
 */
function formatBeefAiRequestError(error) {
  const status = error.response?.status;
  const firstErr = error.response?.data?.errors?.[0];
  const bodySnippet =
    typeof error.response?.data === "string" ? error.response.data.slice(0, 200) : null;
  return (
    firstErr?.message ||
    bodySnippet ||
    error.message ||
    (status ? `Request failed (${status})` : "Network error")
  );
}

/**
 * GET against the Beef AI Directus host — same stack as `videoToolkitFetcher` / portal `axios` usage,
 * but without the main API base URL or portal user token.
 *
 * @param {string} pathWithQuery Path beginning with `/items/...` and including the query string.
 * @returns {Promise<any>} Parsed JSON body (`{ data, meta? }` for Directus).
 */
export async function beefAiGet(pathWithQuery) {
  const path = pathWithQuery.startsWith("/") ? pathWithQuery : `/${pathWithQuery}`;
  const url = `${BEEF_AI_BASE_URL}${path}`;

  try {
    const res = await axios.get(url, { timeout: 120000 });
    return res.data;
  } catch (error) {
    throw new Error(formatBeefAiRequestError(error));
  }
}

/**
 * PATCH against the Beef AI Directus host.
 *
 * @param {string} path Path beginning with `/items/...` (no query string).
 * @param {object} payload Request body.
 * @returns {Promise<any>} Parsed JSON body (`{ data }` for Directus).
 */
export async function beefAiPatch(path, payload) {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const params = new URLSearchParams();
  params.set("access_token", BEEF_AI_ACCESS_TOKEN);
  const url = `${BEEF_AI_BASE_URL}${cleanPath}?${params.toString()}`;

  try {
    const res = await axios.patch(url, payload, { timeout: 120000 });
    return res.data;
  } catch (error) {
    throw new Error(formatBeefAiRequestError(error));
  }
}
